import { render, staticRenderFns } from "./KoioteGraficoQuesito.vue?vue&type=template&id=a0a64c72&lang=es&"
import script from "./KoioteGraficoQuesito.vue?vue&type=script&lang=js&"
export * from "./KoioteGraficoQuesito.vue?vue&type=script&lang=js&"
import style0 from "./KoioteGraficoQuesito.vue?vue&type=style&index=0&id=a0a64c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports